import { Component, ContentChild, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';

import { FooterService } from './footer.service';
/**
 * Footer Left
 */
export class FooterLeftComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-footer-left',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function FooterLeftComponent_tsickle_Closure_declarations() {
/** @type {?} */
FooterLeftComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FooterLeftComponent.ctorParameters;
/** @type {?} */
FooterLeftComponent.propDecorators;
/** @type {?} */
FooterLeftComponent.prototype.templateRef;
}

/**
 * Footer Right
 */
export class FooterRightComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-footer-right',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function FooterRightComponent_tsickle_Closure_declarations() {
/** @type {?} */
FooterRightComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FooterRightComponent.ctorParameters;
/** @type {?} */
FooterRightComponent.propDecorators;
/** @type {?} */
FooterRightComponent.prototype.templateRef;
}

export class FooterComponent implements OnInit {
public footerLeftComponent: FooterLeftComponent;
public footerRightComponent: FooterRightComponent;
/**
 * @param {?} elementRef
 * @param {?} footerService
 */
constructor(
private elementRef: ElementRef,
private footerService: FooterService
  ) {}
/**
 * @return {?}
 */
ngOnInit() {
    this.footerService.elementRef = this.elementRef;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-footer',
  template: `
    <footer class="main-footer">
      <div class="pull-right hidden-xs">
        <ng-template [ngTemplateOutlet]="footerRightComponent?.templateRef"></ng-template>
      </div>
      <ng-template [ngTemplateOutlet]="footerLeftComponent?.templateRef"></ng-template>
    </footer>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: FooterService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'footerLeftComponent': [{ type: ContentChild, args: [FooterLeftComponent, ] },],
'footerRightComponent': [{ type: ContentChild, args: [FooterRightComponent, ] },],
};
}

function FooterComponent_tsickle_Closure_declarations() {
/** @type {?} */
FooterComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FooterComponent.ctorParameters;
/** @type {?} */
FooterComponent.propDecorators;
/** @type {?} */
FooterComponent.prototype.footerLeftComponent;
/** @type {?} */
FooterComponent.prototype.footerRightComponent;
/** @type {?} */
FooterComponent.prototype.elementRef;
/** @type {?} */
FooterComponent.prototype.footerService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
